module.exports = "./img/86e232ece665eb09b640ea09476e43fb.jpg";